<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five">
        <div class="mm-tb">
          <el-table :data="rbList" style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="listName" label="榜单" align="center">
            </el-table-column>
            <el-table-column prop="bowType_text" label="弓种" align="center">
            </el-table-column>
            <el-table-column prop="meterType" label="米数" align="center">
            </el-table-column>
            <el-table-column prop="address" label="积分要求" align="center">
              <template slot-scope="scope"
                >{{ scope.row.pointStart }}-{{ scope.row.pointEnd }}</template
              >
            </el-table-column>
            <el-table-column prop="address" label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="edutRB(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="日赛编辑"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <span style="font-size: 16px">奖励设置</span>
      <div class="dialog-div">
        <span class="title-span"
          >第一名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;奖励积分:</span
        >
        <el-input
          size="small"
          class="title-select"
          v-model="rbEditParams.firstAwardPoint"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >第二名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;奖励积分:</span
        >
        <el-input
          size="small"
          class="title-select"
          v-model="rbEditParams.secondAwardPoint"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >第三名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;奖励积分:</span
        >
        <el-input
          size="small"
          class="title-select"
          v-model="rbEditParams.thirdAwardPoint"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="creatCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRankingListDayPage,
  updatePointAward,
} from "../../api/OperationManagement";

export default {
  name: "5RankingList",
  data() {
    return {
      activeName: "five",
      rbEditParams: {
        id: "",
        firstAwardPoint: "",
        secondAwardPoint: "",
        thirdAwardPoint: "",
        bowType: "",
        listName: "",
        meterType: "",
        pointStart: "",
        pointEnd: "",
      },
      editDialogVisible: false,
      rbResult: {},
      rbList: [],
    };
  },
  mounted() {
    this.getRankingListDayPage();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        // this.$router.push('/OperationManagement/5RankingList');
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    creatCommit() {
      if (this.rbEditParams.firstAwardPoint == "") {
        this.$message.error("请输入第一名奖励积分");
      } else if (this.rbEditParams.secondAwardPoint == "") {
        this.$message.error("请输入第二名奖励积分");
      } else if (this.rbEditParams.thirdAwardPoint == "") {
        this.$message.error("请输入第三名奖励积分");
      } else {
        updatePointAward(this.rbEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("编辑日榜奖励成功");
              this.editDialogVisible = false;
              this.getRankingListDayPage();
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    edutRB(info) {
      this.editDialogVisible = true;
      this.rbEditParams.id = info.id;
      this.rbEditParams.firstAwardPoint = info.firstAwardPoint;
      this.rbEditParams.secondAwardPoint = info.secondAwardPoint;
      this.rbEditParams.thirdAwardPoint = info.thirdAwardPoint;
      this.rbEditParams.bowType = info.bowType;
      this.rbEditParams.listName = info.listName;
      this.rbEditParams.meterType = info.meterType;
      this.rbEditParams.pointStart = info.pointStart;
      this.rbEditParams.pointEnd = info.pointEnd;
    },
    //获取日榜列表
    getRankingListDayPage() {
      getRankingListDayPage().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.rbResult = res.data.result;
            this.rbList = res.data.result.records;
          } else {
            this.rbResult = res.data.result;
            this.rbList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.dialog-div {
  margin: 20px 50px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>
